import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

/**
 * Pesquisa Entrega de obras Cliente Lista.
 * 
 */

type Props = {
  ddlChecklistEntregaObra?: DropDown[];
  ddlCliente?: DropDown[];
  selectedIdsChecklist?: number[];
  selectedIdsCliente?: number[];
  unidade?: string | null;
  localVistoria?: string | null;
  entregue?: number | null;
  tipoVistoria?: number | null;
  dataDe?: Date | null;
  dataAte?: Date | null;

  onClearFilters: () => void;
  handleIdChecklistChange: (v: number[]) => void;
  handleIdClienteChange: (v: number[]) => void;
  handleUnidadeChange: (v: string) => void;
  handleLocalVistoriaChange: (v: string) => void;
  handleEntregueChange: (v: number) => void;
  handleDataRangeChange: (v: Date | null, x: Date | null) => void;
  handleTipoVistoriaChange: (v: number) => void;

};

export const PesquisaVistoriasPanel = ({
  ddlChecklistEntregaObra = [],
  ddlCliente = [],
  selectedIdsChecklist = [],
  selectedIdsCliente = [],
  unidade,
  dataDe,
  dataAte,
  tipoVistoria,
  localVistoria,
  entregue,

  onClearFilters,
  handleIdChecklistChange,
  handleIdClienteChange,
  handleLocalVistoriaChange,
  handleEntregueChange,
  handleUnidadeChange,
  handleDataRangeChange,
  handleTipoVistoriaChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const onTipoVistoriaChange = useCallback((e: SelectChangeEvent<number>) => {
    handleTipoVistoriaChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [handleTipoVistoriaChange]);

  return (
    <CascateList title="Filtros" defaultOpen={false}>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

          <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
            <div className="w-full">
              <DefaultMultiAutocomplete
                label="Cliente"
                value={ddlCliente.filter(x => selectedIdsCliente?.includes(x.id))}
                options={ddlCliente}
                getOptionLabel={x => x.title}
                getOptionKey={x => x.id}
                onChange={x => handleIdClienteChange(x?.map(y => y.id) ?? [])}
              />
            </div>

            <div className="w-full">
              <FormControl size="small" fullWidth>
                <InputLabel id="modulo-dashboard"></InputLabel>
                <Select
                  labelId="modulo-dashboard"
                  value={tipoVistoria ?? 2}
                  onChange={onTipoVistoriaChange}>
                  <MenuItem value={2}>Todos </MenuItem>
                  <MenuItem value={0}>Construtora</MenuItem>
                  <MenuItem value={1}>Cliente</MenuItem>

                </Select>
              </FormControl>

            </div>


            <div className="w-full">
              <DefaultInput
                name="unidade"
                label="Unidade"
                value={unidade ?? ""}
                onChangeValue={handleUnidadeChange}
              />
            </div>


          </div>

          {/* Linha 2 */}
          <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">

            <div className="w-full">
              <DefaultInput
                name="localVistoria"
                label="Local da Vistoria"
                value={localVistoria ?? ""}
                onChangeValue={handleLocalVistoriaChange}
              />
            </div>

            <div className="w-full">
              <DefaultDateRangePickerInput
                label="Data"
                dataDe={dataDe ?? null}
                dataAte={dataAte ?? null}
                onChange={(start, end) => handleDataRangeChange(start, end)}
              />
            </div>


            <div className="w-full">
              <FormControl size="small" fullWidth>
                <InputLabel id="status-entregue">Entregue</InputLabel>
                <Select
                  labelId="status-entregue"
                  label="Entregue"
                  value={entregue ?? 2}
                  onChange={e => handleEntregueChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)}
                >
                  <MenuItem value={2}>Todos </MenuItem>
                  <MenuItem value={0}>Não</MenuItem>
                  <MenuItem value={1}>Sim</MenuItem>

                </Select>
              </FormControl>
            </div>

          </div>
          <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
            <div className="w-full">
              <DefaultMultiAutocomplete
                label="Checklist"
                value={ddlChecklistEntregaObra.filter(x => selectedIdsChecklist?.includes(x.id))}
                options={ddlChecklistEntregaObra}
                getOptionLabel={x => x.title}
                getOptionKey={x => x.id}
                onChange={x => handleIdChecklistChange(x?.map(y => y.id) ?? [])}
              />
            </div>
          </div>


          {/* Botão limpar */}
          <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}
              >
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
};